"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Badge, Button } from "@workspace/frontend-ui";
import type { FC, MouseEvent } from "react";
import type { SelectedProvider } from "../../../types";

type Props = {
  provider: SelectedProvider;
  onRemove: (provider: SelectedProvider) => void;
};

const EnabledProviderBadge: FC<Props> = ({ provider, onRemove }) => {
  const handleRemove = (event: MouseEvent) => {
    event.preventDefault();
    onRemove(provider);
  };

  return (
    <Badge variant="secondary" className="px-1">
      <Button
        variant="secondary"
        size="icon"
        className="bg-background! rounded-full p-0! size-auto!"
        onClick={handleRemove}
      >
        <HugeiconsIcon icon={Cancel01Icon} />
      </Button>
      {provider.name}
    </Badge>
  );
};

export default EnabledProviderBadge;
